var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.IsVisible),expression:"IsVisible"}],staticClass:"grccomp-error-bubble",domProps:{"innerHTML":_vm._s(_vm.ErrorText)}})}
var staticRenderFns = []

export { render, staticRenderFns }